import {
  Divider,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuPortal,
  DropdownMenuTrigger,
  IconButton,
  MenuListItem,
} from '@otter-ai/den-components';
import { DotsHorizontalIcon } from '@otter-ai/den-icons';
import { useState } from 'react';

export type TemplateDropdownMenuItem = {
  label?: string;
  icon?: React.ReactNode;
  action?: () => void;
  className?: string;
  isDivider?: boolean;
  header?: string;
};

type TemplateDropdownOptionsProps = {
  items: (TemplateDropdownMenuItem | null | undefined)[];
  iconSize?: number;
};

export function filterDropdownItems(
  items: (TemplateDropdownMenuItem | null | undefined)[],
): TemplateDropdownMenuItem[] {
  return items.filter(
    (item): item is TemplateDropdownMenuItem =>
      item !== null && item !== undefined,
  );
}

export function TemplateDropdownOptions(props: TemplateDropdownOptionsProps) {
  const { items, iconSize = 20 } = props;
  const filteredItems = filterDropdownItems(items);
  const [open, setOpen] = useState(false);

  if (filteredItems.length === 0) {
    return null;
  }

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <IconButton
          variant="ghost"
          size="sm"
          onMouseDown={(e) => e.preventDefault()}
        >
          <DotsHorizontalIcon size={iconSize} />
        </IconButton>
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent align="end">
          {filteredItems.map((item) => {
            if (item.isDivider) {
              return <Divider orientation="horizontal" className="mt-1 mb-1" />;
            }
            if (item.header) {
              return (
                <MenuListItem className="!hover:none !pointer-events-none">
                  <span className="text-muted text-sm font-semibold">
                    {item.header}
                  </span>
                </MenuListItem>
              );
            }
            return (
              <MenuListItem
                key={item.label}
                className={`font-semibold text-sm ${item.className}`}
                appendStart={item.icon}
                onClick={(e) => {
                  e.stopPropagation();
                  item.action?.();
                  setOpen(false);
                }}
              >
                {item.label}
              </MenuListItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
}
